import setBreakpoint from './setBreakpoint.js';
import getBreakpoint from './getBreakpoint.js';
export default {
  setBreakpoint,
  getBreakpoint
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/core/breakpoints/index.js
// module id = 1139
// module chunks = 9